import { InputDefinition } from '../../interface'

export const authFormInputsDefinition: InputDefinition[] = [
  {
    id: 'username',
    inputType: 'text',
    name: 'username',
    label: 'Nazwa użytkownika lub email',
    placeholder: 'Nazwa użytkownika lub email',
    autoComplete: 'username'
  },
  {
    id: 'password',
    inputType: 'text',
    name: 'password',
    label: 'Hasło',
    placeholder: 'Hasło',
    autoComplete: 'password'
  }
]
